import { RootState } from '@app';

const loggedUserSelector = (state: RootState) => state.loggedUser;
export { loggedUserSelector }; // eslint-disable-line
